export const GET_BIKE_MODEL_OVERVIEW_REQUEST = 'GET_BIKE_MODEL_OVERVIEW_REQUEST';
export const GET_BIKE_MODEL_OVERVIEW_REQUEST_SUCCESS = 'GET_BIKE_MODEL_OVERVIEW_REQUEST_SUCCESS';
export const GET_BIKE_MODEL_OVERVIEW_REQUEST_FAILURE = 'GET_BIKE_MODEL_OVERVIEW_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/constants/get_bike_model_overview.constants.js